import {
  Snackbar as MUISnackbar,
  snackbarContentClasses,
  SnackbarProps,
  styled,
} from "@mui/material";
import { observer } from "mobx-react-lite";

import ErrorIcon from "@/assets/icons/error.svg?react";
import SuccessIcon from "@/assets/icons/success.svg?react";

import styles from "./styles.module.css";

const StyledSnackbar = styled((props: SnackbarProps) => (
  <MUISnackbar {...props} />
))(({ theme }) => ({
  [`& .${snackbarContentClasses.root}`]: {
    padding: "12px 16px",
    backgroundColor: "#202329",
    borderRadius: "8px",
  },
  [`& .${snackbarContentClasses.message}`]: {
    padding: 0,
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "18px",
    letterSpacing: "0.2px",
    color: theme.palette.common.white,
  },
}));

interface IProps extends SnackbarProps {
  message?: string;
  variant?: "success" | "error";
}

const Snackbar = observer(({ message, variant, ...props }: IProps) => {
  return (
    <StyledSnackbar
      autoHideDuration={2000}
      anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
      message={
        <div className={styles.wrapper}>
          {variant === "success" && (
            <SuccessIcon width={24} height={24} color="#34C759" />
          )}
          {variant === "error" && (
            <ErrorIcon width={24} height={24} color="#FF3B30" />
          )}
          <p>{message}</p>
        </div>
      }
      {...props}
    />
  );
});

export default Snackbar;
